// @flow
import {
  compose,
  contains,
  curry,
  fromPairs,
  map,
  pluck,
  propEq,
  reject,
} from 'ramda'

const omitProtected = reject(propEq('isProtected', true))

type Props = {
  databaseId: string,
  displayName: string,
  resourcePath: string,
}

export default class Item {
  databaseId: string
  displayName: string
  isSelected: boolean
  resourcePath: string

  constructor(
    {databaseId, displayName, resourcePath}: Props,
    isSelected: boolean,
  ) {
    this.databaseId = databaseId
    this.displayName = displayName
    this.resourcePath = resourcePath
    this.isSelected = !!isSelected
  }

  get isUnchanged(): boolean {
    return !this.isSelected
  }

  get isChanged(): boolean {
    return this.isSelected
  }

  setSelected(bool: boolean): this {
    this.isSelected = bool
    return this
  }

  toggleSelected(): Item {
    return this.setSelected(!this.isSelected)
  }
}

const makeItemFn = curry((selectedIds, existingItem) => {
  const {databaseId} = existingItem
  const isSelected = contains(databaseId, selectedIds)
  return [databaseId, new Item(existingItem, isSelected)]
})

const fetchIds = pluck('databaseId')

function makeItems(
  fetchNodes: Function,
  source: ?Object = {},
  selectedItems: ?$ReadOnlyArray<Object> = [],
): Item[] {
  const array = compose(omitProtected, fetchNodes)(source)
  const selectedIds = fetchIds(selectedItems)
  const pairs = map(makeItemFn(selectedIds), array)
  return fromPairs(pairs)
}

export {
  makeItems,
}
